import { memo, type ReactNode } from "react";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

type FilterSectionProps = {
  id: string;
  icon: ReactNode;
  title: string;
  children: ReactNode;
};

export const FilterSection = memo(({ id, icon, title, children }: FilterSectionProps) => (
  <AccordionItem value={id} className="border-b border-secondary">
    <AccordionTrigger className="py-4 hover:no-underline" data-testid={`filter-section-${id}`}>
      <div className="flex items-center gap-3 text-sm font-medium text-primary">
        {icon}
        {title}
      </div>
    </AccordionTrigger>
    <AccordionContent className="pb-4" data-testid={`filter-section-${id}-content`}>
      <div className="flex flex-col gap-4">{children}</div>
    </AccordionContent>
  </AccordionItem>
));
